import { getFingerprint } from './commonAuth';
const env = require("../../config.js").default;

const secondsToCheckLogin = 60;
export const nonceSeparator = "|##|";
export const localStorgeSeparator = "##";
/*
  Common library. Functions are divided in sections:

  1. Login and Permissions
  2. API
  3. Language
  4. Utility Functions
  5. Local Storage Managers
  6. Cookies functions
  7. Session Storage Managers

*/

/* ================================================================================================================================================== */


/*  1. Login and Permissions  */
  export const getAppLoginToken = async () => {
    /*
     * This function gets the user token from local storage
     * If in localstorage token is undefined, try get login token from backend
     * Return the user token in case of success, or false in failture case
     *
     */
    var appState = get_localStorage("appState");

    if (appState !== undefined && appState !== null && appState !== "") {
      var isLogin = true;
      var nexCheck = parseInt(window.lastLoginVerify) + (secondsToCheckLogin * 1000);
      if(window.lastLoginVerify === undefined || window.lastLoginVerify === null || window.lastLoginVerify === "" || !parseInt(window.lastLoginVerify) || nexCheck <= (new Date().getTime())){
        isLogin = await verifyLogin();
      }
      if(isLogin)
        return appState;
    }

    if(env.BACKEND_LOGIN_GRANT_TYPE === 'client_credentials'){
      var fetchParams;
      fetchParams = {
        method: "POST",
        headers: new Headers({
          'Content-Type': 'application/x-www-form-urlencoded',
          'Accept-Language': getLanguage(true),
          'Authorization': 'Basic ' + btoa(env.BACKEND_LOGIN_CLIENT_ID + ":" + env.BACKEND_LOGIN_CLIENT_SECRET)
        }),
        body: 'grant_type=' + env.BACKEND_LOGIN_GRANT_TYPE,
      };

      var backend = env.LOGIN_BACKEND ? env.LOGIN_BACKEND : env.BACKEND; //Serve per tenere compatibile con i sistemi che non hanno il settaggio LOGIN_BACKEND
      return fetch(backend + "o/token/", fetchParams).then(function (response) {
        if (!response.ok) {
          var error = Error(response.status);
          error.response = response.json()
          throw error
        }
        return response.json();
      }).then(function (result) {
        set_localStorage("appState", result.access_token);
        return result.access_token;
      }).catch(function(error) {
        return false;
      })
    }else{
      return false;
    }
  }

  export const getAppEnabledVM = async () => {
    /*
     * This function is used to get from backend only enabled
     * Veicle Manufacturer for the app
     */
    return window.cc.enabledVMs
  }
  
  export const getAppEnabledList = () => {
     /*
     * This function is used to get from backend only enabled
     * price list for the app
     */  
    
    return window.cc.enabledList
  }

  export const getDefaultVM = async () => {
    /*
     * This function get defaul vm of catalogue
     */
    var vms = [];
    vms = await getAppEnabledVM();
    if (vms !== undefined && vms !== null && Array.isArray(vms))
      return vms[0];
    else
      return "";
  }

  export const isValidVM = async (vm) => {
    /*
     * This function chek if the recived vm si marked as enabled
     */
    var vms = await getAppEnabledVM();
    return object_value_in_array(vms, 0, vm) > -1;
  }

  export const isEnabledList = async (vm) => {
    var list = await getAppEnabledList();
    if (!vm)
      return !!Object.keys(list).length; // Returns true if list is not empty, false if it's empty

    return vm in list;
  }
  
  export const verifyLogin = async (dontSaveDate = false) => {
    if(!dontSaveDate)
      window.lastLoginVerify = new Date().getTime();
    return await apiCall(env.BACKEND + "test_auth", "GET", {}, true, false, "json").then((response) => {
      if(response.error === false && response.Authenticated){
        return true;
      }
      else
        return false;
    });
  }
  
  export const verifyUrl = async (url) => {
    var data = {url:url};
    return await apiCall(env.BACKEND + "test_url", "GET", data, true, false, "json").then((response) => {
      return response
    })
  }
/* 1. Login and Permissions END */



/* ================================================================================================================================================== */



/* 2. API */
  export function getRandomInt(max) {
    return Math.floor(Math.random() * max);
  }

  export async function apiCall (url, method="GET", data={}, useLogin=false, useCache=false, encodingType="json", useRecaptcha=false){
    /*
     * This function is used to implement the restfull API call to backend.
     *
     * Params:
     * url -> Required, is the full url to the API service (e.g. https://google.com);
     * method -> Optional, is method used by the function to call the service. In case of not known http protocol return false. Default GET;
     * data -> Optional, Object of data you need to pass to the service. You have to use it also with GET services. Default is empty;
     * useLogin -> Optional, boolean. If true this function use user token (if is present in local storage) to call the service as autenticated. Dafault false;
     * useCache -> Optional, boolean. Not implemented. Default false.
     * encodingType -> Optional, json; blob; text.
     *
     * Return: false in case of failture otherwise return and object with response data.
     * If the call fails, object attribute's "error" has full description of error status, else is false
     *
     */

    const $ = window.$;
    var dataToken = null;
    var fetchParams = null;

    if(useRecaptcha){
      let serverTime = await fetch(env.BACKEND + "get_server_time", fetchParams);
      if (!serverTime.ok) {
        throw Error(serverTime.statusText);
      }
      serverTime = await serverTime.json()
      let token = await getFingerprint(serverTime);

      fetchParams = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(token),
      }

      let tokenResponse = await fetch(env.BACKEND + "get_captcha_token", fetchParams);
      if (!tokenResponse.ok) {
        throw Error(tokenResponse.statusText);
      }

      dataToken = await tokenResponse.json();
    }
    
    var login, headers={};

    method = method.toUpperCase();

    if(useLogin){
      // login = getLocalLoginToken();
      if (login === false) {
        return false;
      }
    }

    if(!isValidHTTPProtocol(method)){
      return false;
    }
    headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Accept-Language': getLanguage(true),
    };
    if(useLogin){
      // headers.authorization = "Bearer " + login;
      var loginToken = await getAppLoginToken();
      headers.authorization = "Bearer " + loginToken;
    }

    if(method==="GET" && !$.isEmptyObject(data)){
      var params=[];
      for (const key in data) {
        params.push(encodeURIComponent(key) + '=' + encodeURIComponent(data[key]));
      }

      if (useRecaptcha) {
        params.push('gToken=' + dataToken['signed_token']);
        params.push('gTokenExpires=' + dataToken['token_time']);
      }

      params = params.join('&');
      url = url + "?" + params;
    }
    headers = new Headers(headers);
    
    fetchParams = {
      method: method,
      headers: headers,
    };

    if(method!=="GET"){
      if (useRecaptcha) {
        data.gToken = dataToken['signed_token'];
        data.gTokenExpires = dataToken['expires_at'];
      }
      fetchParams.body = JSON.stringify(data);
    }

    if(encodingType === "json"){
      return fetch(url, fetchParams)
        .then(function (response) {
          if (!response.ok) {
            throw Error(response.statusText);
          }
          return response.json();
        })
       .then(function(result){
          result.error = false;
          return result;
        })
        .catch(function(error) {
          return {error: error};
      });
    }else if(encodingType === "blob"){
      return fetch(url, fetchParams)
       .then(function(response) {
          return response.blob();
        })
        .then(function(myBlob) {
          return URL.createObjectURL(myBlob);
        });
    }else{
      return fetch(url, fetchParams)
       .then(function(response) {
          return response.text();
        });
    }
  }

/* 2. API End */



/* ================================================================================================================================================== */



/* 3. Language */
  function getBrowserLanguage(){
    /*
     * This function get the browser default language and check if it's present in app's avaible languages.
     * If language is present in array return it, else return the dafualt app language.
     * In case of failture return false
     *
     */
    var browserLang = navigator.language || navigator.userLanguage;
    browserLang = browserLang.substr(0,2).toLowerCase();
    return browserLang;
  }

  export function getLanguage(browserLang = true){
    /*
     * This function return preferred user language. Calculates it inbase 3 params.
     * If is setted return local storage language;
     * else return preferred language from backend; -- NOT IMPLEMENTED
     * If backend is empty or user isn't logged in return default browser language
     *
     */
    var language = false;
    if(get_localStorage("language") !== null && get_localStorage("language") !== undefined && get_localStorage("language") !== "")
      language = get_localStorage("language");
    else
      if(browserLang)
        language = getBrowserLanguage();

    //Ne caso in cui non sia ancora stato caricato nessun file di configurazione, setto momentaneamente lingua inglese
    if(language === false)
      return "en";

    //localStorage["language"] = language;

    return language;
  }

  export function getLanguageMoment(){
    //Restituisce la lingua dell'utente con eccezioni per moment js
    var language = getLanguage(false);

    if(language.toLowerCase() === "en")
      language = "en-gb";

    return language;
  }

  export function getLanguageDatePicker(){
    //Restituisce la lingua dell'utente con eccezioni per datepicker
    var language = getLanguage(false);

    if(language.toLowerCase() === "en")
      language = "en-GB";

    return language;
}
  
  export function getLanguageLocale(){
    //Restituisce la lingua dell'utente in formato Locale JS per formattazione prezzo
    var language = getLanguage(false);
    var out = language + "-" + language.toUpperCase();
    if(language === "en")
      out = "en-GB";

    return out;
  }

  export function getTrad(label_id){
    /*
     * Funzione di traduzione stringhe statiche del template. Paramentri:
     * label_id -> String. contiene la stringa da tradurre
     * La funzione restituisce:
     *  - la stringa tradotta nel caso in cui venga trovata nell'oggetto evn.labels contentente tutte le traduzioni disponibili;
     *  - La stringa originale nel caso in cui non sia stata trovata alcuna traduzione
     * **************************************************************************************************
     * Per facilitare lo sviluppo, la funzione può salvare in un file tutte le stringhe trovate senza una corrispondente traduzione.
     * Questa funzionalità è attivabile tramite la variabile d'ambiente MISSING_TRANSLATIONS_ALERT
     */
    if (label_id in env.labels){
        return env.labels[label_id];
    }
    else {
      if(env.MISSING_TRANSLATIONS_ALERT){
        var traduzioniMancanti;
        if(sessionStorage["traduzioniMancanti"] && sessionStorage["traduzioniMancanti"] !== "" && sessionStorage["traduzioniMancanti"] !== undefined && sessionStorage["traduzioniMancanti"] !== null)
          traduzioniMancanti = JSON.parse(sessionStorage["traduzioniMancanti"]);
        else
          traduzioniMancanti = [];
        if(traduzioniMancanti.indexOf(label_id)<=-1)
          traduzioniMancanti.push(label_id);
        sessionStorage["traduzioniMancanti"] = JSON.stringify(traduzioniMancanti);
      }

      return label_id;
    }
  }

  export function setInitialLanguage(){
    /*
     * Function used to set default language of very first access to the app.
     * Try for max. 10 times to get browser language. In case of failture set en as default.
     * In case there is a language in local storage nothing returns
     *
     */
    var tent = 0, language=false;
    if(get_localStorage("language") !== null && get_localStorage("language") !== undefined && get_localStorage("language") !== "")
      return
    do{
      if(get_localStorage("language") !== null && get_localStorage("language") !== undefined && get_localStorage("language") !== "")
        language = get_localStorage("language");
      else
        language = getBrowserLanguage();
      tent ++;
    }while (language === false && tent<10);

    //Chek if language is supported by software
    if (!(language in env.languageName))
      language = false;

    if(language === false)
      language = "en";

    set_localStorage("language", language);
    return
  }

  export function setLanguage(language){
    /*
     * This function is used to set user's selected language.
     * Get the new language by params, check if is avaible in app.
     * If isn't avaible function fail else save it in: local storage and in backend (NOT IMPLEMENTED),
     * then reload the page with new language.
     *
     */
     language = language.toLowerCase();
     if(window.cc.languages.indexOf(language)<0)
       return;

     //var oldLanguage = get_localStorage("language");
     set_localStorage("language", language);
     setCookie("I18N_LANGUAGE", language.toLowerCase());
     remove_localStorage('currentLanguage');
     remove_localStorage('labels');

     window.location.reload();

     return false;
  }


  export function setDefaultLang(language){
    language = language.toLowerCase();
    if(window.cc.languages.indexOf('sq')<=-1)
      return 'en';
   return false;
  }
/* 3. Language END */




/* ================================================================================================================================================== */




/* 4. Utility Functions */
  export function getParam(parameterName) {
    /*
     * This function is used to get "GET" parameter from URL
     * Params:
     * parameterName -> String, required. Is the GET parameter which is looking for.
     * Returning:
     * The parameter value in case of success
     * null in case of failture
     *
     */
    var result = null, tmp = [];
    window.location.search
        .substr(1)
        .split("&")
        .forEach(function (item) {
          tmp = item.split("=");
          if (tmp[0] === parameterName)
            result = decodeURIComponent(tmp[1]);
        });
    return result;
  }

  export function inIframe() {
		try {
			return window.self !== window.top;
		} catch (e) {
			return true;
		}
	}

  export var isValidHTTPProtocol=(str)=>{
    /*
     * This function check if the http protocol recived as param is valid.
     * Valid protocols are "GET", "POST", "PUT", "DELETE".
     */
    const validProtocols = ["GET", "POST", "PUT", "PATCH", "DELETE"];

    for (var i=0; i<validProtocols.length; i++){
      if(validProtocols[i] === str){
        return true;
      }
    }
    return false
  }

  export async function is_updateNeeded(){
    /*
     * This function is used to check if some updates are avible.
     * It checks the version of backend product and compares it with localStorage versions.
     * No params needed
     * Returning:
     * True:
     *      - If the local versions and the remote versions are different
     *      - If there was an error with the apiCall and the local "updateCounter" is lower than 0 (the first check time)
     * False:
     *      - If local and remote versions are equal
     *      - If there was an error and the local "updateCounter" is greather than 0 (from the second check time)
     */

    return apiCall(env.BACKEND + "software_version").then((version) => {
      var actualVersion = "";
      actualVersion = get_localStorage("actualVersion");
      if(version.error === false){
        remove_localStorage("updateCounter");
        set_localStorage("actualVersion", version.version);

        if(actualVersion !== version.version){
          return true;
        }
        return false;
      }else{
        var updateCounter = get_localStorage("updateCounter");
        if(updateCounter === undefined || updateCounter === null || parseInt(updateCounter) <= 0){
          updateCounter = 1
          set_localStorage("updateCounter", updateCounter);

          return  (actualVersion === undefined || actualVersion === null || actualVersion === "" || actualVersion === "false");
        }
        set_localStorage("actualVersion", "false");
        return false;
      }
    })
  }

  export function getNazioniPortale(filtra){
    /*
     * This function gets countries from custom config and returns them.
     * Params:
     * filtra -> Boolean, required.
     *           If true this function returns only european countries
     *           If false returns all countries
     * Returning:
     * A list of objects. (in case of failture an empty list)
     */
    var nazioni = window.cc.nazioni;
    var nazioniPortale = [];
    if(filtra === true){
      nazioni.map(function(index, key){
        if(index.TNAZITNA !== undefined && index.TNAZITNA !== null && index.TNAZITNA === 'EU' ){
          nazioniPortale.push(index);
        }
        return false
      });
      return nazioniPortale;
    }else{
      return nazioni;
   }
  }


  export function object_value_in_array(array, key, value){
    var index = -1;

    if(!Array.isArray(array))
      return index;

    for(var i=0; i<array.length; i++){
      if(array[i][key] !== undefined && array[i][key] !== null && array[i][key] === value){
        index = i;
        break;
      }
    }
    return index;
}
  
export function formatCurrency(number, thousandsSeparator, decimalSeparator, symbol=null) {
  const [integerPart, decimalPart] = number.toFixed(2).split('.');
  const integerWithSeparators = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);
  let out = decimalPart ? integerWithSeparators + decimalSeparator + decimalPart : integerWithSeparators;
  if (symbol !== null)
    // TODO: prevedere posizione simbolo valuta prima o dopo cifra, in base a valuta
    return out + " " + symbol;
  return out;
}

export function cloneFromState(obj) {
  return JSON.parse(JSON.stringify(obj));
}
/* 4. Utility Functions END */



/* ================================================================================================================================================== */



/* 5. Local Storage Managers */
  export function get_localStorage(name){
    /*
     * This function is used to get data from localStorage.
     * It's necessary because we could ave multiple app on the same domain name,
     * so the local storage wouldn't be different between the different application.
     * To solve this, this function get only the local storage parameters saved as:
     * parameter_name##application_base_path , where in application_base_path / are replaceed by _
     * Params:
     * name -> String, required. The parameter name without basepath suffix
     * Returning:
     * The local storage parameter value
     */
    const padding = localStorage_padding();
    return localStorage[name + padding];
  }

  export function set_localStorage(name, value){
    /*
     * This function is used to save data in local storage.
     * Obiective and rules are the same of the get function.
     * Params:
     * name -> String, required. The parameter name without basepath suffix
     * value -> Number or string, required. The value to save in local storge
     */
    const padding = localStorage_padding();
    return localStorage.setItem(name + padding, value);
  }

  export function remove_localStorage(name){
    /*
     * This function is used to delete an item from local storage
     * Obiective and rules are the same of the get and set function.
     * Params:
     * name -> String, required. The parameter name without basepath suffix
     */
    const padding = localStorage_padding();
    return localStorage.removeItem(name + padding);
  }

  export function removeCommon_localStorage(name){
    /*
     * Remove all localstorage entries with the same name but different paddina
     * Params:
     * name -> String, required. The parameter name without basepath suffix
     */
    var keys=Object.keys(localStorage);
    for (var i = 0; i < keys.length; i++){
      if(keys[i].search(name + localStorgeSeparator) > -1)
        localStorage.removeItem(keys[i]);
    }
  }

  export function clear_localStorage(){
    /*
     * Remove all localStorage items for this portal.
     * It remove all localstorge that has the same padding
     */
    const padding = localStorage_padding();

    for (var i = 0; i < localStorage.length; i++){
      if(localStorage.key(i).search(padding) > -1)
        localStorage.removeItem(localStorage.key(i));
    }
  }

  function localStorage_suffix(){
    /*
     * Returns the localstorge standard suffix.
     * It's calculated replacing basepath slashes (/) with underscore (_)
     */
    return "B2C_" + env.BASEPATH.replace("/", "_");
  }

  function localStorage_padding(){
    /*
     * Returns the usual padding for localstorage.
     * It's calculated adding two ashes (##) before the localStorage_suffix return
     */
    return localStorgeSeparator + localStorage_suffix();
  }
/* 5. Local Storage Managers END */



/* ================================================================================================================================================== */



/* 6. Cookies functions */

  export function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  export function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

/* 6. Cookies functions */



/* ================================================================================================================================================== */



/* 7. session Storage Managers */
  export function get_sessionStorage(name){
    /*
     * This function is used to get data from sessionStorage.
     * It's necessary because we could ave multiple app on the same domain name,
     * so the session storage wouldn't be different between the different application.
     * To solve this, this function get only the session storage parameters saved as:
     * parameter_name##application_base_path , where in application_base_path / are replaceed by _
     * Params:
     * name -> String, required. The parameter name without basepath suffix
     * Returning:
     * The session storage parameter value
     */
    const padding = sessionStorage_padding();
    return sessionStorage[name + padding];
  }

  export function set_sessionStorage(name, value){
    /*
     * This function is used to save data in session storage.
     * Obiective and rules are the same of the get function.
     * Params:
     * name -> String, required. The parameter name without basepath suffix
     * value -> Number or string, required. The value to save in session storge
     */
    const padding = sessionStorage_padding();
    return sessionStorage.setItem(name + padding, value);
  }

  export function remove_sessionStorage(name){
    /*
     * This function is used to delete an item from session storage
     * Obiective and rules are the same of the get and set function.
     * Params:
     * name -> String, required. The parameter name without basepath suffix
     */
    const padding = sessionStorage_padding();
    return sessionStorage.removeItem(name + padding);
  }

  export function clear_sessionStorage(){
    /*
     * Remove all sessionStorage items for this portal.
     * It remove all sessionstorge that has the same padding
     */
    const padding = sessionStorage_padding();

    for (var i = 0; i < sessionStorage.length; i++){
      if(sessionStorage.key(i).search(padding) > -1)
        sessionStorage.removeItem(sessionStorage.key(i));
    }
  }

  function sessionStorage_suffix(){
    /*
     * Same of localStorage_suffix
     */
    return localStorage_suffix();
  }

  function sessionStorage_padding(){
    /*
     * Same of localStorage_padding
     */
    return localStorage_padding();
  }
/* 7. session Storage Managers END */



/* ================================================================================================================================================== */
